'use strict';

module.exports = {
    /**
     * 获取地理位置接口<br />
     * 对应native接口：geolocation.getCurrentPosition
     * @method hysdk.getLocation
     * @category Device
     * @example ./getLocation.js[1-25]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   √ (https) |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    getLocation: {
        hy: {
            key: 'geolocation.getCurrentPosition'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    type: 'wechat',
                    coords: {
                        latitude: ret.latitude,
                        longitude: ret.longitude
                    }
                };
            }
        },
        h5: {
            // 新版chrome要求：getCurrentPosition()和watchPosition() 不再支持http等非安全协议.
            handle: function handle() {
                var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (data) {
                        opt.success({
                            type: 'h5',
                            coords: data.coords
                        });
                    }, opt.fail, {
                        enableHighAccuracy: !!opt.enableHighAccuracy,
                        timeout: opt.timeout || 5000
                    });
                } else {
                    opt.fail({
                        ret: false,
                        errcode: -1,
                        errmsg: 'Geolocation is not supported!'
                    });
                }
            }
        }
    },
    /**
     * 使用经纬度打开地图<br />
     * 对应native接口：openLocation
     * @method hysdk.openLocation
     * @category Device
     * @example ./openLocation.js[1-12]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    openLocation: {
        hy: {
            //TODO Android是否支持？
            key: 'openLocation'
        },
        wechat: {
            key: 'openLocation'
        }
    },
    /**
     * 获取设备信息<br />
     * 对应native接口：native.getDeviceInfo
     * @method hysdk.getDeviceInfo
     * @category Device
     * @example ./getDeviceInfo.js[1-25]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     * 苹果设备 model 映射关系请参考<a href="http://ued.qunar.com/hy2/hysdk/appendix.html#苹果设备映射表" target="_blank">附录</a>
     */
    getDeviceInfo: {
        hy: {
            key: 'native.getDeviceInfo'
        }
    },
    /**
     * 获取网络状态<br />
     * 对应native接口：network.getType
     * @method hysdk.getNetworkType
     * @category Device
     * @example ./getNetworkType.js[1-12]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    getNetworkType: {
        hy: {
            key: 'network.getType'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    networkType: ret.networkType
                };
            }
        }
    },
    /**
     * 注册监听后，就会监听页面的截屏事件。一旦用户进行了截屏操作，就会在屏幕右侧有个中间页提示分享<br />
     * 对应native接口：registerScreenshotShare
     * @method hysdk.registerScreenshot
     * @category Device
     * @example ./registerScreenshotShare.js[1-11]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    registerScreenshot: {
        hy: {
            key: 'registerScreenshot'
        }
    },
    /**
     * 当页面退出，或者不需要截屏监听的时候，就需要移除这个监听了。<br />
     * 对应native接口：unregisterScreenshot
     * @method hysdk.unregisterScreenshot
     * @category Device
     * @example ./unregisterScreenshotShare.js[1-3]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    unregisterScreenshot: {
        hy: {
            key: 'unregisterScreenshot'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/device.js
// module id = 14
// module chunks = 0 2 4